import { DownloadEngine, IEngineItem } from '../../../../model/api-modules';

export const getEngineName = (
  engineJson: ReadonlyArray<IEngineItem>
): string => {
  if (!engineJson || engineJson.length === 0) {
    return '-';
  }

  const engineTypes = engineJson.map((item) => item.type);
  const engineNames = engineTypes.map((engineType) => {
    switch (engineType) {
      case DownloadEngine.UEPlugin:
        return 'UE Plugin';
      case DownloadEngine.CPP:
        return 'C++';
      case DownloadEngine.UnityPlugin:
        return 'Unity Plugin';
      default:
        return '-';
    }
  });

  return engineNames.join(', ');
};

export const getPlatformOptions = (): { label: string; value: number }[] => {
  return [
    { label: 'Android', value: 1 },
    { label: 'iOS', value: 2 },
    { label: 'Windows', value: 3 },
    { label: 'Mac', value: 4 },
    { label: 'PS4', value: 5 },
    { label: 'PS5', value: 6 },
    { label: 'XSX', value: 7 },
    { label: 'Switch', value: 8 },
  ];
};
